import styled from '@emotion/styled/macro'
import { Box, Button, Switch } from '@mui/material'
import theme from 'theme'

export const Wrapper = styled(Box)`
  width: 584px;
  margin: 0 auto;
  padding: 40px;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  border: 1px solid ${theme.colors.borderMedium};
  background: ${theme.colors.surfaceContainerBackground};
  display: flex;
  flex-direction: column;
  gap: 36px;
`

export const SectionTitle = styled(Box)`
  color: ${theme.colors.menuItemText};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 20px;
  font-weight: ${theme.typography.fontWeight.normal};
  line-height: 1;
`

export const ConnectionCard = styled(Box)`
  border-radius: ${theme.attributes.borderRadius.tertiary};
  border: 1px solid ${theme.colors.borderMedium};
  background: ${theme.colors.labelCardBg};
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const ConnectionHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
`

export const PendingBadge = styled(Box)`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  background: rgba(255, 188, 108, 0.16);
  color: ${theme.colors.warning};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 12px;
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: 18px;
  letter-spacing: 0.1px;
  width: fit-content;

  html[data-theme='light'] & {
    background: #ffbc6c;
    color: #ba5800;
  }
`

export const DomainInfo = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;

  .icon-wrapper {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${theme.colors.devicesRowHoverBg};
    border-radius: ${theme.attributes.borderRadius.tertiary};
    flex-shrink: 0;

    svg path {
      stroke: ${theme.colors.dropdownLabel};
    }
  }

  .info-content {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .info-label {
      color: ${theme.colors.devicesSecondaryText};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: 14px;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 22px;
    }

    .info-value {
      color: ${theme.colors.menuItemText};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: 14px;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 20px;
      letter-spacing: 0.1px;
    }
  }
`

export const EditButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  padding: 8px 24px 8px 16px;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  background: ${theme.colors.btnTertiaryBg};
  text-transform: none;

  svg path {
    stroke: ${theme.colors.cta};
  }

  &:hover {
    background: ${theme.colors.cta};

    svg path {
      stroke: ${theme.colors.calendarBg};
    }

    .button-text {
      color: ${theme.colors.calendarBg};
    }
  }

  &:disabled {
    background: ${theme.colors.devicesRowHoverBg};
    opacity: 0.5;

    svg path {
      stroke: ${theme.colors.btnSecondaryDisabledText};
    }

    .button-text {
      color: ${theme.colors.btnSecondaryDisabledText};
    }
  }

  .button-text {
    color: ${theme.colors.cta};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: 14px;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 22px;
    text-align: center;
  }
`

export const ConnectionToggle = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .toggle-label {
    color: ${theme.colors.menuItemText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: 14px;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 20px;
  }
`

export const StyledSwitch = styled(Switch)`
  width: 38px;
  height: 20px;
  padding: 0;

  .MuiSwitch-switchBase {
    padding: 3px;

    &.Mui-checked {
      transform: translateX(18px);

      & + .MuiSwitch-track {
        background-color: transparent;
        border-color: ${theme.colors.strokePrimary};
        opacity: 1;
      }

      .MuiSwitch-thumb {
        background-color: ${theme.colors.cta};
      }
    }
  }

  .MuiSwitch-thumb {
    width: 14px;
    height: 14px;
    background-color: ${theme.colors.btnSecondaryDisabledText};
    box-shadow: none;
  }

  .MuiSwitch-track {
    border-radius: 35px;
    background-color: transparent;
    border: 2px solid ${theme.colors.strokePrimary};
    opacity: 1;
  }
`

export const AddButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  padding: 13px 16px 13px 24px;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  background-color: ${theme.colors.cta} !important;
  text-transform: none;

  &:hover {
    background-color: #c477c1 !important;
  }

  &:disabled {
    background-color: ${theme.colors.cta} !important;
    opacity: 0.5;
  }

  .button-text {
    color: ${theme.colors.surfaceContainerBackground};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: 14px;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 22px;
  }
`

export const EmptyState = styled(Box)`
  .empty-title {
    color: ${theme.colors.foreground};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.huge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 52px;
    margin-bottom: ${theme.spacing.small}px;
  }

  .empty-desc {
    color: ${theme.colors.menuItemText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xxLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 28px;
    margin-bottom: 34px;
  }

  .empty-img {
    position: absolute;
    right: 0;
    bottom: 0;
  }
`
